module.exports = __webpack_public_path__ + "img/Frame-8.svg";